import { getStoreSheds } from './api'

function firstNonEmptyString(...vals) {
  for (const v of vals) {
    if (v != null && v !== '') return String(v)
  }
  return ''
}

/** distinct 接口记录 → { stockCode, stockName }[] */
export function distinctRecordsToStockOptions(list) {
  const map = {}
  ;(list || []).forEach((item) => {
    const code = firstNonEmptyString(item.stockCode, item.storeNo, item.locationCode)
    if (!code) return
    if (!map[code]) {
      const name = firstNonEmptyString(
        item.stockName,
        item.storeName,
        item.locationName,
        code
      )
      map[code] = {
        stockCode: code,
        stockName: name.trim() || code
      }
    }
  })
  return Object.values(map)
}

/** avue select dicData：{ label, value }，数据来自 base_store 煤棚 */
export async function fetchStockShedDicData() {
  const { data } = await getStoreSheds()
  const list = (data && data.data) || []
  return list.map((item) => ({
    label: item.storeName || item.storeNo,
    value: item.storeNo
  }))
}
